// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-23jhstXo","stock_box":"stock_box-3MYAynu8"};